module.exports = __webpack_public_path__ + "static/media/radiation-alt.c95c1c46.svg";